<script setup lang="ts">
import WarningIcon from '@/assets/icons/WarningIcon.vue';
</script>

<template>
  <div class="flex items-start gap-sm mt-sm">
    <WarningIcon class="shrink-0 size-icon-xs text-warning" />
    <span class="text-warning text-xs">{{ $t('general.noSeatsAvailableForInvitation') }}</span>
  </div>
</template>
